import { useFilterStore } from "@/shared/stores/useFilterStore.ts";
import { hasValues } from "@/shared/utils/validator/has-values.ts";

export function applyDefaultIfEmpty<T extends object>(
  obj: T | undefined | null,
  defaultValue: T,
  addToStore: boolean,
  key?: string,
  hasValuesFn: (obj: unknown) => boolean = hasValues,
): T {
  const isValid = hasValuesFn(obj);

  if (!isValid && addToStore && key) {
    const { setDefaultValue } = useFilterStore.getState();
    setDefaultValue(key, defaultValue);
  }

  return isValid ? (obj as T) : defaultValue;
}


